import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import PageTitle from '../../components/pageTitle/PageTitle'
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import { motion } from 'framer-motion';
import axiosRequest from '../../services/axios/axiosRequest';
import Loading from '../../components/loading/Loading';
import styles from './aboutUs.module.css';
import DOMPurify from 'dompurify';


export default function AboutUs() {

  const [about, setAbout] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const aboutController = new AbortController();
    axiosRequest('/about/', { signal: aboutController.signal })
      .then(res => setAbout(res.data))
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false));
    return () => aboutController.abort();
  }, []);

  return (
    <>
      <Helmet>
        <title>درباره ما - نوآوران پژوه</title>
        <meta name="description" content="شرکت نوآوران پژوه وارد کننده مواد شیمیایی و تجهیزات آزمایشگاهی با بهرمندی از مدیریت و پرسنل مجرب در زمینه علوم آزمایشگاهی، دارویی و شیمیایی در خدمت شما محققین گرامی میباشد" />
      </Helmet>

      <Header />
      <main className='mainContainer container-lg'>
        <PageTitle title='درباره ما' style={{ marginBottom: '1.5rem' }} />
        {isLoading ? <Loading /> :
          <>
            <motion.div
              initial={{ scale: 1.2 }}
              animate={{ scale: 1 }}
              transition={{ ease: 'easeOut', duration: 0.5, }}
            >
              <img className={styles.banner} src="/assets/images/footer/footerBg.jpg" alt="npcmed" />
            </motion.div>
            <div className='container-md d-flex flex-column gap-4 mt-5' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(about.description) }}></div>
          </>
        }
      </main>
      <Footer />
    </>
  )
}
